import { render, staticRenderFns } from "./NotificationBellMessage.vue?vue&type=template&id=50ccb316&scoped=true&"
import script from "./NotificationBellMessage.vue?vue&type=script&lang=js&"
export * from "./NotificationBellMessage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBellMessage.vue?vue&type=style&index=0&id=50ccb316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ccb316",
  null
  
)

export default component.exports